import { render, staticRenderFns } from "./InboxLetterId.vue?vue&type=template&id=44e23026"
import script from "./InboxLetterId.vue?vue&type=script&lang=js"
export * from "./InboxLetterId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports